'use client'

import { Accordion as AccordionPrimitive } from '@base-ui/react/accordion'
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'

import cn from '@config/tailwind/cn'

function Accordion({ className, ...props }: AccordionPrimitive.Root.Props) {
  return (
    <AccordionPrimitive.Root
      data-slot='accordion'
      className={cn('ui:flex ui:w-full ui:flex-col', className)}
      {...props}
    />
  )
}

function AccordionItem({ className, ...props }: AccordionPrimitive.Item.Props) {
  return (
    <AccordionPrimitive.Item data-slot='accordion-item' className={cn('ui:not-last:border-b', className)} {...props} />
  )
}

function AccordionTrigger({ className, children, ...props }: AccordionPrimitive.Trigger.Props) {
  return (
    <AccordionPrimitive.Header className='ui:flex'>
      <AccordionPrimitive.Trigger
        data-slot='accordion-trigger'
        className={cn(
          'ui:focus-visible:ring-main-blue-100/50 ui:focus-visible:border-main-blue-100 ui:focus-visible:after:border-main-blue-100 ui:**:data-[slot=accordion-trigger-icon]:text-neutrals-n-75 ui:group/accordion-trigger ui:relative ui:flex ui:flex-1 ui:items-start ui:justify-between ui:rounded-lg ui:border ui:border-transparent ui:py-2.5 ui:text-left ui:text-sm ui:font-medium ui:transition-all ui:outline-none ui:hover:underline ui:focus-visible:ring-[3px] ui:disabled:pointer-events-none ui:disabled:opacity-50 ui:**:data-[slot=accordion-trigger-icon]:ml-auto ui:**:data-[slot=accordion-trigger-icon]:size-4',
          className,
        )}
        {...props}
      >
        {children}
        <ChevronDownIcon
          data-slot='accordion-trigger-icon'
          className='ui:pointer-events-none ui:shrink-0 ui:group-aria-expanded/accordion-trigger:hidden'
        />
        <ChevronUpIcon
          data-slot='accordion-trigger-icon'
          className='ui:pointer-events-none ui:hidden ui:shrink-0 ui:group-aria-expanded/accordion-trigger:inline'
        />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  )
}

function AccordionContent({ className, children, ...props }: AccordionPrimitive.Panel.Props) {
  return (
    <AccordionPrimitive.Panel
      data-slot='accordion-content'
      className='ui:data-open:animate-accordion-down ui:data-closed:animate-accordion-up ui:overflow-hidden ui:text-sm'
      {...props}
    >
      <div
        className={cn(
          'ui:[&_a]:hover:text-neutrals-black ui:h-(--accordion-panel-height) ui:pt-0 ui:pb-2.5 ui:data-ending-style:h-0 ui:data-starting-style:h-0 ui:[&_a]:underline ui:[&_a]:underline-offset-3 ui:[&_p:not(:last-child)]:mb-4',
          className,
        )}
      >
        {children}
      </div>
    </AccordionPrimitive.Panel>
  )
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
